module.exports = __webpack_public_path__ + "img/vip-pic.48d60bc.png";